exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Map__map___31I8z {\n  width: 100%;\n  height: 100%;\n}\n.Map__container___Qn7WK {\n  width: 100%;\n}\n\n.Map__googleMapContainer___1HUZj {\n  height: 425px;\n  width: 100%;\n}\n\n@media (min-width: 800px) {\n  .Map__container___Qn7WK {\n    height: 100%;\n  }\n  .Map__googleMapContainer___1HUZj {\n    height: 100%;\n    width: 100%;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"map": "Map__map___31I8z",
	"container": "Map__container___Qn7WK",
	"googleMapContainer": "Map__googleMapContainer___1HUZj"
};